import { start } from '@jutro/app';
import { initDefaultGA, initDefaultMixpanel } from '@jutro/events';
import { consumerThemeConfig } from '@jutro/theme-styles';
import { LocaleService } from 'gw-portals-i18n-react';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';

import 'regenerator-runtime';

import App from './app/App';

const { trackingConfig = {}, authentication = {} } = appConfig;

const gaTrackingId = trackingConfig.GA_TRACKING_ID;
const mixpanelTrackingId = trackingConfig.MIXPANEL_TRACKING_ID;


if (gaTrackingId) {
    initDefaultGA(trackingConfig);
}
if (mixpanelTrackingId) {
    initDefaultMixpanel(trackingConfig);
}

let cloudAuthConfig = {};
if (authentication.authServer === 'okta') {
    cloudAuthConfig = authentication.servers.okta;
}

const axa400 = '#00008f';
const axaWhite = '#fff';
const axaSuccess = '#138636';
const axaError = '#C91432';
const axaWarning = '#FFBC11';
const axaOcean200 = '#4976ba';
const axaBG1 = '#63a1d6';
const axaTextColor1 = '#28333f';
// const axaTextColor2 = '#848484';
const axaTextColor2 = '#373737';
const axaTextColor3 = '#fff';
const axaNone = 'none';

const axaTheme = {
    name: 'axaTheme',
    rootStyle: {
        ...consumerThemeConfig.rootStyle,
        '--GW-FOCUS-COLOR-LIGHT': axaNone,

        '--GW-ACCENT-COLOR': axa400,

        '--GW-FOCUS-COLOR': axa400,
        '--GW-COLOR-SUCCESS': axaSuccess,
        '--GW-COLOR-ERROR': axaError,
        '--GW-COLOR-WARNING': axaWarning,
        '--GW-COLOR-INFO': axaOcean200,
        '--GW-SELECTOR-SELECTED-BACKGROUND-COLOR': axaOcean200,

        '--GW-BACKGROUND-COLOR': axaWhite,
        '--GW-BACKGROUND-COLOR-BODY': axaWhite,

        '--GW-TOP-NAV-BACKGROUND-COLOR': axaBG1,

        '--GW-TOP-NAV-ITEM-BACKGROUND-COLOR': axaBG1,
        '--GW-TOP-NAV-ITEM-BACKGROUND-COLOR-ACTIVE': axaBG1,
        '--GW-TOP-NAV-ITEM-BACKGROUND-COLOR-HOVER': 'rgba(0, 0, 0, 0.05)',

        '--GW-BRAND-COLOR-2': axaOcean200,

        '--GW-MODAL-HEADER-BACKGROUND-COLOR': axaOcean200,
        '--GW-BACKGROUND-COLOR-ELEMENT-ACTIVE': axa400,
        '--GW-BRAND-COLOR-1': axa400,

        '--GW-BUTTON-FILLED-BACKGROUND-COLOR': axa400,
        '--GW-BUTTON-FILLED-BACKGROUND-COLOR-HOVER': axa400,
        '--GW-BUTTON-OUTLINED-COLOR': axa400,
        '--GW-BUTTON-OUTLINED-COLOR-HOVER': axaWhite,

        '--GW-BRAND-COLOR-1-HOVER': axa400,

        '--GW-TEXT-COLOR-1': axaTextColor1,
        '--GW-TEXT-COLOR-2': axaTextColor2,
        '--GW-TEXT-COLOR-3': axaTextColor3,
        '--GW-TOP-NAV-ITEM-COLOR': axaWhite,
        '--GW-TOP-NAV-ITEM-COLOR-ACTIVE': axaWhite,
        '--GW-TOP-NAV-ITEM-UNDERLINE-WIDTH': '0rem',

        '--GW-FONT-SIZE-BODY': '0.8rem',

        '--GW-LINK-COLOR': axa400,
        '--GW-LINK-COLOR-HOVER': '#000043',

        '--GW-TEXT-DECORATION-UNDERLINE': axaOcean200,

        '--GW-FONT-SIZE-H1': '1.5rem',
        '--GW-LINE-HEIGHT-H1': '2rem',
        '--GW-FONT-SIZE-H2': '1.25rem',
        '--GW-LINE-HEIGHT-H2': '1.75rem',
        '--GW-FONT-SIZE-H3': '0.875rem',
        '--GW-LINE-HEIGHT-H3': '1.125rem',
        '--GW-FONT-SIZE-H4': '0.875rem',
        '--GW-LINE-HEIGHT-H4': '1.125rem',
        '--GW-FONT-SIZE-H5': '0.75rem',
        '--GW-LINE-HEIGHT-H5': '1rem',
        '--GW-HEADER-LOGO-SIZE': '3.5rem',
        '--GW-FONT-SIZE-LABEL': '0.8rem',
        '--GW-FONT-SIZE-INPUT': '0.8rem'

    }
};

start(App, {
    rootId: 'root',
    messageLoader: LocaleService.loadMessages,
    coreMessageLoader: LocaleService.loadCoreMessages,
    refreshOnLanguageOrLocaleChange: true,
    config: [cloudAuthConfig],
    routerBasename: '/vendor-engage',
    onInit: () => {
        LocaleService.register();
    },
    appName: {
        id: 'digital.appName',
        defaultMessage: 'VendorEngage'
    },
    themeConfig: axaTheme,
    appDescription: 'Portal de proveedores AXA Mexico'
});
